
import OrderBoxSell from '@/components/OrderBox/OrderBoxSell'
import OrderBoxNew from '@/components/OrderBox/OrderBoxNew'
import OrderBoxBuyer from '@/components/OrderBox/OrderBoxBuyer'
import CollectionBox from '@/components/CollectionBox'
import UserInfoBox from '@/components/UserInfoBox'
import BargainSuccessTips from '@/components/Bargain/success-tips/index.vue'
export default {
	components: {
		OrderBoxSell,
		OrderBoxNew,
		OrderBoxBuyer,
		CollectionBox,
		UserInfoBox,
		BargainSuccessTips
	},
	mounted() {
		this.$store.dispatch('user/UserGetInfo')
	},
	methods: {
		// openBargainSuccessTips() {
		// 	const model = this.$pzDialog(
		// 		{
		// 			width: '450px',
		// 			title: '砍价成功提醒',
		// 			showClose: true,
		// 			customClass: 'bargain-success-tips',
		// 			showCancelButton: false,
		// 			component: BargainSuccessTips,
		// 			confirmButtonText: '立即购买',
		// 			onConfirm: () => {
		// 				model.remove()
		// 			},
		// 			onCancel: async () => {
		// 				model.remove()
		// 			}
		// 		},
		// 		this
		// 	)
		// }
	},
	head() {
		return {
			title: '个人中心-账号登录-盼之代售-手游网游账号买号卖号平台',
			meta: [
				{
					hid: 'description',
					name: 'description',
					content: '欢迎登录盼之代售的个人中心，这里是一个有爱的游戏账号交易平台。贴心、安全、高效的账号交易服务，保证您的游戏账号安全。'
				},
				{
					hid: 'keywords',
					name: 'keywords',
					content: '个人中心，游戏账号交易，盼之代售'
				}
			]
		}
	}
}
